import { queryOptions } from '@tanstack/react-query';
import type { User } from '@/common/user';
import { axios } from '@/lib/utils/axios';
import { type CommonResponse, getResponseAndErrorMessage, type SuccessErrorResponse } from '../common';
import { API_URLS } from '../query.client';

export type ProfileResponseType = CommonResponse<User>;

async function profile(): Promise<SuccessErrorResponse<User>> {
	const response = await axios(`${API_URLS.USERS.PROFILE}`, {
		method: 'GET',
	});
	return getResponseAndErrorMessage<User>(response.data);
}

export function getProfileOptions({ enabled = true }: { enabled?: boolean } = {}) {
	return queryOptions({
		queryKey: ['users', 'profile'],
		queryFn: () => profile(),
		enabled,
	});
}
